module["exports"] = [
  "#{street_prefix} #{Address.street_title}",
  "#{Address.street_title} #{street_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/street_name.js
// module id = 1663
// module chunks = 0